// src/Components/Promo/PortfolioEmail.js

import { saveAs } from 'file-saver';

// --- HELPERS ---

const encodeUTF8ToBase64 = (str) => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }),
  );
};

export const getPortfolioEmailContent = (data) => {
  const {
    title,
    subjectTitle,
    salutation,
    emailClose,
    pdfDownloadUrl,
    pdfThumbnailUrl,
    mode,
    logo,
    emailFrom,
    defaultFontType = 'Arial',
    socialLinks,
    docId,
    appUrl,
  } = data;

  let formattedSalutationHtml = '';
  let formattedCloseHtml = '';
  let plainTextBody = '';

  const senderEmail = emailFrom || 'news@updates.loktr.net';
  const emailSubject = subjectTitle || title || 'Newsfeed';

  let headerHtml = `
    <div style="border-bottom: 2px solid #cccccc; margin-bottom: 20px; padding-bottom: 10px; font-family: ${defaultFontType}, Arial, sans-serif; font-size: 14px; color: #333333;">
      <div style="margin-bottom: 4px;"><b>From:</b> ${senderEmail}</div>
      <div style="margin-bottom: 4px;"><b>To:</b> You</div>
      <div><b>Subject:</b> <span style="font-weight: normal;">${emailSubject}</span></div>
    </div>
  `;
  plainTextBody += `From: ${senderEmail}\r\nTo: You\r\nSubject:${emailSubject}\r\n\r\n`;

  if (salutation && salutation.trim().length > 0) {
    formattedSalutationHtml = salutation.replace(/\n/g, '<br/>') + '<br/><br/>';
    plainTextBody += salutation + '\r\n\r\n';
  }

  if (emailClose && emailClose.trim().length > 0) {
    formattedCloseHtml = emailClose.replace(/\n/g, '<br/>');
    plainTextBody += emailClose;
  }

  let footerBrandingHtml = '';
  if (appUrl || logo) {
    const displayUrl = appUrl ? appUrl.replace(/^https?:\/\//, '') : '';

    let linkHtml = '';
    if (appUrl) {
      linkHtml = `
        <div style="margin-bottom: ${logo ? '15px' : '0'}; font-family: ${defaultFontType}, Arial, sans-serif; font-size: 14px; text-align: center;">
          <a href="${appUrl}" target="_blank" style="color: #0056b3; text-decoration: none; font-weight: bold;">${displayUrl}</a>
        </div>
      `;
    }

    let logoHtml = '';
    if (logo) {
      logoHtml = `
        <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="margin: 0 auto; width: 100%; max-width: 400px;">
          <tr>
            <td align="center">
              <img src="${logo}" alt="Client Logo" style="max-width: 200px; height: auto; display: block;" />
            </td>
          </tr>
        </table>
      `;
    }

    footerBrandingHtml = `
      <div style="margin-top: 40px; padding-top: 20px; text-align: center;">
        ${linkHtml}${logoHtml}
      </div>
    `;
  }

  let socialMediaHtml = '';
  if (socialLinks && Array.isArray(socialLinks)) {
    const activeLinks = socialLinks.filter((l) => l.url && l.url.trim() !== '');
    if (activeLinks.length > 0) {
      let iconsHtml = activeLinks
        .map((link) => {
          let iconUrl = '';
          switch (link.platform.toLowerCase()) {
            case 'facebook':
              iconUrl = 'https://img.icons8.com/color/48/000000/facebook-new.png';
              break;
            case 'instagram':
              iconUrl = 'https://img.icons8.com/color/48/000000/instagram-new.png';
              break;
            case 'linkedin':
              iconUrl = 'https://img.icons8.com/color/48/000000/linkedin.png';
              break;
            case 'youtube':
              iconUrl = 'https://img.icons8.com/color/48/000000/youtube-play.png';
              break;
            case 'x':
              iconUrl = 'https://img.icons8.com/?size=48&id=ClbD5JTFM7FA&format=png';
              break;
            default:
              iconUrl = '';
          }
          if (!iconUrl) return '';
          return `<a href="${link.url.trim()}" target="_blank" rel="noopener noreferrer" data-pm-no-track style="text-decoration: none; margin: 0 8px; display: inline-block;">
                  <img src="${iconUrl}" alt="${link.platform}" width="32" height="32" style="display: block; width: 32px; height: 32px; border: 0;" />
                </a>`;
        })
        .join('');

      socialMediaHtml = `
        <div style="margin-top: 30px; text-align: center;">
          ${iconsHtml}
        </div>
      `;
    }
  }

  let unsubscribeHtml = '';
  if (mode === 'NEWSFEED') {
    unsubscribeHtml = `
      <div style="margin-top: 40px; text-align: center; font-size: 12px; color: #999999; border-top: 1px solid #eeeeee; padding-top: 20px;">
        <p>If you no longer wish to receive these updates, you can <a href="{{{ pm:unsubscribe }}}" style="color: #999999; text-decoration: underline;">unsubscribe from this list</a>.</p>
      </div>
    `;
    plainTextBody += `\r\n\r\n---\r\nIf you no longer wish to receive these updates, unsubscribe here: {{{ pm:unsubscribe }}}\r\n`;
  }

  let targetLink = pdfDownloadUrl;
  if (mode === 'NEWSFEED' && docId && appUrl) {
    targetLink = `${appUrl}/download-newsfeed?id=${docId}`;
  }

  const fakeViewerHtml =
    pdfDownloadUrl && pdfThumbnailUrl
      ? `
    <div style="margin-top: 20px; margin-bottom: 30px;">
      <table role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 400px; border: 1px solid #dddddd; border-radius: 8px; background-color: #f8f9fa; padding: 15px; margin: 0;">
        <tr>
          <td align="center">
            <a href="${targetLink}" target="_blank" title="" style="text-decoration: none; display: block;">
              <img src="${pdfThumbnailUrl}" width="350" title="" style="display: block; width: 100%; max-width: 350px; height: auto; border: 1px solid #cccccc; box-shadow: 0 4px 8px rgba(0,0,0,0.1); margin-bottom: 20px;" alt="Document Preview" />
            </a>
            
            <div>
              <a href="${targetLink}" target="_blank" title="" style="background-color: #0056b3; border-radius: 4px; color: #ffffff; display: inline-block; font-family: ${defaultFontType}, Arial, sans-serif; font-size: 15px; font-weight: bold; line-height: 44px; text-align: center; text-decoration: none; width: 200px; -webkit-text-size-adjust: none;">
                View Full PDF
              </a>
              </div>

          </td>
        </tr>
      </table>
    </div>
  `
      : '';

  plainTextBody += `\r\n\r\nDocument Link: ${targetLink}\r\n\r\n`;
  if (appUrl) {
    plainTextBody += `Website: ${appUrl}\r\n`;
  }

  const htmlBody = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>${emailSubject}</title>
</head>
<body style="margin: 0; padding: 20px; font-family: ${defaultFontType}, Arial, sans-serif; font-size: 14px; line-height: normal; color: #333333; text-align: left; background-color: #ffffff;">
  ${headerHtml}
  ${formattedSalutationHtml}${fakeViewerHtml}
  <br/>
  ${formattedCloseHtml}${footerBrandingHtml}
  ${socialMediaHtml}${unsubscribeHtml}
</body>
</html>`;

  return { htmlBody, plainTextBody };
};

export const generatePortfolioEmail = async (data) => {
  try {
    const { title, subjectTitle, bccList, partIndex, emailFrom } = data;

    const { htmlBody, plainTextBody } = getPortfolioEmailContent(data);

    const base64Html = encodeUTF8ToBase64(htmlBody);
    const chunksHtml = base64Html.match(/.{1,76}/g) || [];
    const chunkedBase64Html = chunksHtml.join('\r\n');

    const boundaryAlt = `----=_AltPart_${Date.now()}`;
    const cleanTitle = title || 'Portfolio';
    const emailSubject = subjectTitle || title || 'Portfolio';
    const partSuffix = partIndex !== undefined ? `_Part${partIndex + 1}` : '';

    const senderEmail = emailFrom || 'news@updates.loktr.net';

    const headers = [
      `X-Unsent: 1`,
      `From: ${senderEmail}`,
      `To: `,
      `Subject: ${emailSubject}`,
    ];

    if (bccList && Array.isArray(bccList) && bccList.length > 0) {
      headers.push(`Bcc: ${bccList.join(', ')}`);
    }

    headers.push(`MIME-Version: 1.0`);
    headers.push(`Content-Type: multipart/alternative; boundary="${boundaryAlt}"`);

    const emlContentArray = [
      ...headers,
      ``,
      `--${boundaryAlt}`,
      `Content-Type: text/plain; charset="UTF-8"`,
      `Content-Transfer-Encoding: 7bit`,
      ``,
      plainTextBody,
      ``,
      `--${boundaryAlt}`,
      `Content-Type: text/html; charset="UTF-8"`,
      `Content-Transfer-Encoding: base64`,
      ``,
      chunkedBase64Html,
      ``,
      `--${boundaryAlt}--`,
    ];

    const emlContent = emlContentArray.join('\r\n');

    const blob = new Blob([emlContent], { type: 'message/rfc822' });
    saveAs(blob, `${cleanTitle}${partSuffix}.eml`);
  } catch (error) {
    console.error('Error generating Email:', error);
    throw error;
  }
};
